export const heapTrack = (name, properties = {}) => {
  try {
    window.heap.track(name, properties);
  } catch (err) {
    console.log('Heap Track Error', err);
    return null;
  }
};

export const materializeToastErrorResponse = errorObject => {
  if (errorObject === null)
    Materialize.toast(
      "We're having trouble saving. Please refresh and try again",
      5000,
      'red'
    );
  for (var key in errorObject) {
    Materialize.toast(errorObject[key][0], 4000, 'red');
  }
};

export const jwHostname = ebEnv => {
  switch (ebEnv) {
    case 'production':
      return 'app.jerseywatch.com';
    case 'stage':
      return 'stage.jerseywatch.com';
    default:
      return 'app.jerseywatch.localhost';
  }
};
